import type { KeyedHighlight } from 'chessboard/plugins/highlights/config/types';

/**
 * Determine whether or not the two highlights are the same.
 */
export function highlightsHaveSameKeyAndColor(first: KeyedHighlight, second: KeyedHighlight) {
  return first.key === second.key && first.data.color === second.data.color;
}
